export default "__VITE_ASSET__ULTUNgm6__";